var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_446_4043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 21.7574C16.5228 21.7574 21 17.2803 21 11.7574C21 6.2346 16.5228 1.75745 11 1.75745C5.47715 1.75745 1 6.2346 1 11.7574C1 17.2803 5.47715 21.7574 11 21.7574Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 21.7574C16.5228 21.7574 21 17.2803 21 11.7574C21 6.2346 16.5228 1.75745 11 1.75745C5.47715 1.75745 1 6.2346 1 11.7574C1 17.2803 5.47715 21.7574 11 21.7574Z",
    fill: "#FDE37A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 11.7574C1 6.23463 5.47719 1.75745 11 1.75745C16.5228 1.75745 21 6.23463 21 11.7574",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 11.7574C1 6.23463 5.47719 1.75745 11 1.75745C16.5228 1.75745 21 6.23463 21 11.7574",
    fill: "#6EABF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_446_4043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(1 1.75745)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.8c6b1e23f11c306b6a2ec927aacf9acf.svg";
export { ForwardRef as ReactComponent };